<template>
  <article
    class="flex flex-col justify-between gap-12 rounded-[20px] px-20 py-24 text-left md:gap-0 md:py-32"
  >
    <header>
      <component :is="props.icon" class="mb-8 size-32 md:mb-16" />
      <h4 class="heading-3">{{ props.heading }}</h4>
    </header>

    <slot />
  </article>
</template>

<script lang="ts" setup>
import type { Component } from 'vue'

const props = defineProps<{
  heading: string
  icon: Component
}>()
</script>
